import * as type from "../types/pipeline";

const initialState = {
  selections: [],
  fetchAllPipelines: {
    status: null,
    loading: true,
    error: null,
  },
  fetchSinglePipeline: {
    status: null,
    loading: true,
    error: null,
  },
  moveUnit: {
    status: null,
    loading: false,
    error: null,
  },
  updatedData: {
    status: null,
    loading: false,
    error: null,
  },
  search: {
    status: null,
    loading: false,
    error: null,
  },
  addUnit: {
    status: null,
    loading: false,
    error: null,
  },
  updateUnit: {
    status: null,
    loading: false,
    error: null,
  },
  deleteUnit: {
    status: null,
    loading: false,
    error: null,
  },
  createPipeline: {
    status: null,
    loading: false,
    error: null,
    id: null,
  },
  deletePipeline: {
    status: null,
    loading: false,
    error: null,
  },
  updatePipeline: {
    status: null,
    loading: false,
    error: null,
    id: null,
  },
  activePipeline: {
    id: null,
    name: null,
    units: [],
    data: [],
  },
  activeUnit: {
    id: null,
    name: null,
  },
  editPipeline: {
    id: null,
    nuame: null,
    units: [],
  },
  showModals: {
    addUnitPipelineModal: false,
    editUnitPipelineModal: false,
    newPipelineModal: false,
    editPipelineModal: false,
    deletePipelineUnitModal: false,
  },
};

export const pipeline = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_FETCH_ALL_PIPELINES:
      return {
        ...state,
        selections: [],
        fetchAllPipelines: {
          ...state.fetchAllPipelines,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_FETCH_ALL_PIPELINES:
      return {
        ...state,
        selections: [],
        fetchAllPipelines: {
          ...state.fetchAllPipelines,
          status: null,
          loading: false,
          error: payload.error,
        },
      };
    case type.GRANT_FETCH_ALL_PIPELINES:
      return {
        ...state,
        selections: payload.content,
        fetchAllPipelines: {
          ...state.fetchAllPipelines,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_FETCH_ALL_PIPELINES:
      return {
        ...state,
        selections: [],
        fetchAllPipelines: {
          ...state.fetchAllPipelines,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_SINGLE_PIPELINE_DETAILS:
      return {
        ...state,
        fetchSinglePipeline: {
          ...state.fetchSinglePipeline,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_PIPELINE_DETAILS:
      return {
        ...state,
        fetchSinglePipeline: {
          ...state.fetchSinglePipeline,
          status: null,
          loading: false,
          error: payload.message,
        },
        activePipeline: {
          id: null,
          name: null,
          units: [],
          data: [],
        },
      };

    case type.SET_SINGLE_PIPELINE_DETAILS:
      return {
        ...state,
        activePipeline: payload.content,
        fetchSinglePipeline: {
          ...state.fetchSinglePipeline,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_SINGLE_PIPELINE_DETAILS:
      return {
        ...state,
        fetchSinglePipeline: {
          ...state.fetchSinglePipeline,
          status: null,
          loading: false,
          error: null,
        },
        activePipeline: {
          id: null,
          name: null,
          units: [],
          data: [],
        },
      };
    case type.NULL_SINGLE_PIPELINE_DETAILS:
      return {
        ...state,
        fetchSinglePipelineLoading: false,
        fetchSinglePipelineError: null,
        fetchSinglePipelineStatus: null,
      };
    case type.REQUEST_MOVE_PIPELINE_DATA:
      return {
        ...state,
        moveUnit: {
          ...state.moveUnit,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_MOVE_PIPELINE_DATA:
      return {
        ...state,
        moveUnit: {
          ...state.moveUnit,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_MOVE_PIPELINE_DATA:
      return {
        ...state,
        moveUnit: {
          ...state.moveUnit,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_MOVE_PIPELINE_DATA:
      return {
        ...state,
        moveUnit: {
          ...state.moveUnit,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATED_PIPELINE_DETAILS:
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATED_PIPELINE_DETAILS:
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_UPDATED_PIPELINE_DETAILS:
      return {
        ...state,
        activePipeline: payload.content,
        updatedData: {
          ...state.updatedData,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATED_PIPELINE_DETAILS:
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.CHANGE_PIPELINES_MODALS:
      if (
        payload.modal.addUnitPipelineModal === true ||
        payload.modal.addUnitPipelineModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addUnitPipelineModal: payload.modal.addUnitPipelineModal,
          },
        };
      } else if (
        payload.modal.newPipelineModal === true ||
        payload.modal.newPipelineModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newPipelineModal: payload.modal.newPipelineModal,
          },
        };
      } else if (
        payload.modal.editUnitPipelineModal === true ||
        payload.modal.editUnitPipelineModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editUnitPipelineModal: payload.modal.editUnitPipelineModal,
          },
        };
      } else if (
        payload.modal.editPipelineModal === true ||
        payload.modal.editPipelineModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editPipelineModal: payload.modal.editPipelineModal,
          },
        };
      } else if (
        payload.modal.deletePipelineUnitModal === true ||
        payload.modal.deletePipelineUnitModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deletePipelineUnitModal: payload.modal.deletePipelineUnitModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_SEARCH_SINGLE_COMPANY:
      return {
        ...state,
        search: {
          ...state.search,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SEARCH_SINGLE_COMPANY:
      return {
        ...state,
        search: {
          ...state.search,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_SEARCH_SINGLE_COMPANY:
      return {
        ...state,
        search: {
          ...state.search,
          status: payload.response,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SEARCH_SINGLE_COMPANY:
      return {
        ...state,
        search: {
          ...state.search,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_SINGLE_OPPORTUNITY:
      return {
        ...state,
        addUnit: {
          ...state.addUnit,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_SINGLE_OPPORTUNITY:
      return {
        ...state,
        addUnit: {
          ...state.addUnit,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_OPPORTUNITY:
      return {
        ...state,
        addUnit: {
          ...state.addUnit,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_SINGLE_OPPORTUNITY:
      return {
        ...state,
        addUnit: {
          ...state.addUnit,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_ACTIVE_PIPELINE_UNIT:
      return {
        ...state,
        activeUnit: payload.unit,
      };
    case type.RESET_ACTIVE_PIPELINE_UNIT:
      return {
        ...state,
        activeUnit: {
          ...state.activeUnit,
          id: null,
          name: null,
        },
      };
    case type.REQUEST_UPDATE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        updateUnit: {
          ...state.updateUnit,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        updateUnit: {
          ...state.updateUnit,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        updateUnit: {
          ...state.updateUnit,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        updateUnit: {
          ...state.updateUnit,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        deleteUnit: {
          ...state.deleteUnit,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        deleteUnit: {
          ...state.deleteUnit,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        deleteUnit: {
          ...state.deleteUnit,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_SINGLE_OPPORTUNITY:
      return {
        ...state,
        deleteUnit: {
          ...state.deleteUnit,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_CREATE_NEW_PIPELINE:
      return {
        ...state,
        createPipeline: {
          ...state.createPipeline,
          status: null,
          loading: true,
          error: null,
          id: null,
        },
      };
    case type.SET_CREATE_NEW_PIPELINE:
      return {
        ...state,
        createPipeline: {
          ...state.createPipeline,
          status: "success",
          loading: false,
          error: null,
          id: payload.id,
        },
      };
    case type.REVOKE_CREATE_NEW_PIPELINE:
      return {
        ...state,
        createPipeline: {
          ...state.createPipeline,
          status: null,
          loading: false,
          error: payload.message,
          id: null,
        },
      };
    case type.RESET_CREATE_NEW_PIPELINE:
      return {
        ...state,
        createPipeline: {
          ...state.createPipeline,
          status: null,
          loading: false,
          error: null,
          id: null,
        },
      };
    case type.SET_EDIT_SINGLE_PIPELINE:
      return {
        ...state,
        editPipeline: payload.pipeline,
      };
    case type.RESET_EDIT_SINGLE_PIPELINE:
      return {
        ...state,
        editPipeline: {
          ...state.editPipeline,
          id: null,
          name: null,
          units: [],
        },
      };
    case type.REQUEST_DELETE_SINGLE_PIPELINE:
      return {
        ...state,
        deletePipeline: {
          ...state.deletePipeline,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_PIPELINE:
      return {
        ...state,
        deletePipeline: {
          ...state.deletePipeline,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_SINGLE_PIPELINE:
      return {
        ...state,
        deletePipeline: {
          ...state.deletePipeline,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.GRANT_DELETE_SINGLE_PIPELINE:
      return {
        ...state,
        deletePipeline: {
          ...state.deletePipeline,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_SINGLE_PIPELINE:
      return {
        ...state,
        updatePipeline: {
          ...state.updatePipeline,
          status: null,
          loading: true,
          error: null,
          id: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_PIPELINE:
      return {
        ...state,
        updatePipeline: {
          ...state.updatePipeline,
          status: null,
          loading: false,
          error: payload.message,
          id: null,
        },
      };
    case type.RESET_UPDATE_SINGLE_PIPELINE:
      return {
        ...state,
        updatePipeline: {
          ...state.updatePipeline,
          status: null,
          loading: false,
          error: null,
          id: null,
        },
      };
    case type.GRANT_UPDATE_SINGLE_PIPELINE:
      return {
        ...state,
        updatePipeline: {
          ...state.updatePipeline,
          status: "success",
          loading: false,
          error: null,
          id: payload.id,
        },
      };
    default:
      return state;
  }
};
